class BulkSplitShipModal {
  constructor() {
    this.bssSelector = '.pc-Style-BssAwareness, .pc-ProductCard-BssAwareness';
    this.tagCategory = 'bss modal';
    this.openSelector =
      '.pc-Style-BssAwareness-link, .pc-ProductCard-BssAwareness-link';
    this.openBulkSplitShipModal = this.openBulkSplitShipModal.bind(this);
    this.clickBulkSplitShipModalButton = this.clickBulkSplitShipModalButton.bind(
      this
    );
    this.clickBulkSplitShipModalTemplate = this.clickBulkSplitShipModalTemplate.bind(
      this
    );
    this.clickBulkSplitShipModalPhone = this.clickBulkSplitShipModalPhone.bind(
      this
    );
    this.clickBulkSplitShipModalChat = this.clickBulkSplitShipModalChat.bind(
      this
    );
    this.initBehavior();
    this.reConstructor();
  }

  reConstructor() {
    $('.pc-Products .pc-ProductCard-BssAwareness-Version1').removeClass('is-HiddenOnLoad');
  }

  initBehavior() {
    const subCatName = $('.pc-Styles').data('name');
    const isEligible = $(this.bssSelector).length > 0;


    this.tagAction = (subCatName && subCatName.toLowerCase()) || 'pdp';
    $(document).on('click', this.openSelector, (e) => {
      this.openBulkSplitShipModal(e, this.tagCategory, this.tagAction);
    });
    $(document).on('click', '.sb-Js-BssAwareness-start', (e) => {
      this.clickBulkSplitShipModalButton(e, this.tagCategory, this.tagAction);
    });
    $(document).on('click', '.sb-Js-BssAwareness-template', (e) => {
      this.clickBulkSplitShipModalTemplate(e, this.tagCategory, this.tagAction);
    });
    $(document).on('click', '.sb-Js-BssAwareness-phone', (e) => {
      this.clickBulkSplitShipModalPhone(e, this.tagCategory, this.tagAction);
    });
    $(document).on('click', '.sb-Js-BssAwareness-chat', (e) => {
      this.clickBulkSplitShipModalChat(e, this.tagCategory, this.tagAction);
    });
    $(document).on(
      'click',
      '.mfp-container:not(.mfp-content), .mfp-close',
      (e) => {
        this.clickBulkSplitShipModalClose(e, this.tagCategory, this.tagAction);
      }
    );
  }

  // Private: Event Handlers

  openBulkSplitShipModal(evt, category, action) {
    if (evt !== null) {
      evt.preventDefault();
    }

    CustomInk.Metrics.fireEvent({
      category: category,
      action: action,
      label: 'learn more'
    });
    return StyleBitz.BssAwarenessModal.magnificInit();
  }

  clickBulkSplitShipModalButton(evt, category, action) {
    if (evt !== null) {
      evt.preventDefault();
    }

    CustomInk.Metrics.fireEvent({
      category: category,
      action: action,
      label: 'keep browsing'
    });
    $('.sb-BssAwareness-modal .mfp-close').trigger('click');
  }

  clickBulkSplitShipModalTemplate(evt, category, action) {
    CustomInk.Metrics.fireEvent({
      category: category,
      action: action,
      label: 'template'
    });
  }

  clickBulkSplitShipModalPhone(evt, category, action) {
    CustomInk.Metrics.fireEvent({
      category: category,
      action: action,
      label: 'phone'
    });
  }

  clickBulkSplitShipModalChat(evt, category, action) {
    $('.sb-BssAwareness-modal .mfp-close').trigger('click');
    CustomInk.Metrics.fireEvent({
      category: category,
      action: action,
      label: 'chat'
    });
  }

  clickBulkSplitShipModalClose(evt, category, action) {
    evt.stopPropagation();
    evt.stopImmediatePropagation();
    if (evt.target === evt.currentTarget) {
      CustomInk.Metrics.fireEvent({
        category: category,
        action: action,
        label: 'close'
      });
    }
  }
}

jQuery(() => (ProductCatalog.BulkSplitShipModal = new BulkSplitShipModal()));
